import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GlobalSettingsRoutingModule } from './global-settings-routing.module';
import { GlobalSettingsComponent } from './pages/global-settings/global-settings.component';
import { GlobalSettingsDAEngineerModule } from '../../da-engineer/global-settings/global-settings.module';
import { GlobalSettingsEffects } from './store/global-settings.effects';
import { GlobalSettingsReducer } from './store/global-settings.reducer';
import {
  ExceptionsClient,
  GlobalAdminsClient,
  UserConfigClient,
} from 'src/app/shared/models/autogenerated';
import { GlobalSettingsTitleHorizontalLineComponent } from './components/global-settings-title-horizontal-line/global-settings-title-horizontal-line.component';

@NgModule({
  declarations: [
    GlobalSettingsComponent,
    GlobalSettingsTitleHorizontalLineComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    GlobalSettingsDAEngineerModule,
    GlobalSettingsRoutingModule,
    StoreModule.forFeature('global-settings', GlobalSettingsReducer),
    EffectsModule.forFeature([GlobalSettingsEffects]),
  ],
  exports: [GlobalSettingsTitleHorizontalLineComponent],
  providers: [UserConfigClient, GlobalAdminsClient, ExceptionsClient],
})
export class GlobalSettingsModule {}
